import ContenutoImmagineVideo from './ContenutoImmagineVideo';
import "./SezioneContenuto.css"; // usa lo stile unificato

export default function SezioneDettaglio(props) {
  return (
    <section className="sezione-contenuto">
      <div className="contenuto">
        {/* Titolo mobile: visibile solo su layout verticale */}
        <h2 className="titolo-mobile">{props.titolo}</h2>

        <div className="immagine">
          <ContenutoImmagineVideo {...props} />
        </div>

        <div className="testo">
          {/* Titolo desktop: visibile solo su layout orizzontale */}
          <h2 className="titolo-desktop">{props.titolo}</h2>
          <p dangerouslySetInnerHTML={{ __html: props.descrizione }} />
        </div>
      </div>
    </section>
  );
}


